import {
  getSurveyDetailsApi,
  updateSurveyApi,
  updateShortSurveyApi,
  submitSurveyApi,
  activeSurveysApi,
  archivedSurveysApi,
  surveyResultApi,
  getKickstartSurveyListApi,
  shareExperienceApi,
  getSharedExperienceApi,
  getSharedExperienceListApi,
  createSurveyApi,
  getSurveyApi,
  updateSurveyKickStartApi,
  getDriversApi,
  getTemplateListApi,
  getSelectedTemplateApi,
  setTemplateApi,
  getSettingsApi,
  setSettingsApi,
  getRemindersApi,
  saveRemindersApi,
  getSurveyValidationApi,
  startSurveyApi,
  uploadEmployeesCSVApi,
  getParticipantsApi,
  putParticipantsCohortApi,
} from 'api/engagement';
import ColorCodedDate from 'models/common/ColorCodedDate';

export const getSurveyDetails = async ({ surveyId }) => {
  const res = await getSurveyDetailsApi({ surveyId });
  return {
    ...res.entity,
    endDateFormatted: ColorCodedDate.fromJSON(res.entity.endDateFormatted),
  };
};

export const updateSurvey = async ({ surveyId, surveyQuestionId, selectedOptionId, feedbackText }) => {
  const res = await updateSurveyApi({ surveyId, surveyQuestionId, selectedOptionId, feedbackText });
  return res.entity;
};

export const updateShortSurvey = async ({ surveyId, surveyQuestionId, selectedOptionId, feedbackText }) => {
  const res = await updateShortSurveyApi({
    surveyId,
    surveyQuestionId,
    selectedOptionId,
    feedbackText,
  });
  return res.entity;
};

export const submitSurvey = async ({ surveyId }) => {
  const res = await submitSurveyApi({ surveyId });
  return res.entity;
};

export const getActiveSurveys = async ({ offset = 0, limit = 20 }) => {
  const res = await activeSurveysApi({ offset, limit });
  return {
    ...res.entity,
    surveys: res.entity.surveys.map((item) => ({
      ...item,
      endDateFormatted: ColorCodedDate.fromJSON(item.endDateFormatted),
    })),
  };
};

export const getArchivedSurveys = async ({ offset = 0, limit = 20 }) => {
  const res = await archivedSurveysApi({ offset, limit });
  return {
    ...res.entity,
    surveys: res.entity.surveys.map((item) => ({
      ...item,
      endDateFormatted: ColorCodedDate.fromJSON(item.endDateFormatted),
    })),
  };
};

export const getSurveyResult = async ({ surveyId }) => {
  const res = await surveyResultApi({ surveyId });
  return { ...res.entity, endDateFormatted: ColorCodedDate.fromJSON(res.entity.endDateFormatted) };
};

export const getKickstartSurveyList = () => getKickstartSurveyListApi().then((res) => res.entity);

export const shareExperience = async ({ sharedWith, isAnonymous, experiencePost }) => {
  const res = await shareExperienceApi({ sharedWith, isAnonymous, experiencePost });
  return res.entity;
};

export const getSharedExperienceList = async () => {
  const res = await getSharedExperienceListApi();
  return res.entity.map((item) => ({
    ...item,
    createdDateFormatted: ColorCodedDate.fromJSON(item.createdDateFormatted),
  }));
};

export const getSharedExperience = async ({ experienceId }) => {
  const res = await getSharedExperienceApi({ experienceId });
  return {
    ...res.entity,
    createdDateFormatted: ColorCodedDate.fromJSON(res.entity.createdDateFormatted),
  };
};

// survey kickstart
export const createSurvey = async ({ body }) => {
  const res = await createSurveyApi({ body });
  return res.entity;
};

export const getSurvey = async ({ surveyId }) => {
  const res = await getSurveyApi({ surveyId });
  return res.entity;
};

export const updateSurveyKickStart = async ({ body }) => {
  const res = await updateSurveyKickStartApi({ body });
  return res.entity;
};

export const getDrivers = async () => {
  const res = await getDriversApi();
  return res.entity;
};

export const getTemplateList = async ({ includeSample = false }) => {
  const res = await getTemplateListApi({ includeSample });
  return res.entity;
};

export const getSelectedTemplate = async ({ surveyId }) => {
  const res = await getSelectedTemplateApi({ surveyId });
  return res.entity;
};

export const setTemplate = async ({ surveyId, templateId }) => {
  const res = await setTemplateApi({ surveyId, templateId });
  return res.entity;
};

export const getSettings = async ({ surveyId }) => {
  const res = await getSettingsApi({ surveyId });
  return res.entity;
};

export const setSettings = async ({ surveyId, body }) => {
  const res = await setSettingsApi({ surveyId, body });
  return res.entity;
};

export const getReminders = async ({ surveyId }) => {
  const res = await getRemindersApi({ surveyId });
  return res.entity;
};

export const saveReminders = async ({ surveyId, body }) => {
  const res = await saveRemindersApi({ surveyId, body });
  return res.entity;
};

export const getSurveyValidation = async ({ surveyId }) => {
  const res = await getSurveyValidationApi({ surveyId });
  return res.entity;
};

export const startSurvey = async ({ surveyId }) => {
  const res = await startSurveyApi({ surveyId });
  return res.entity;
};

export const uploadEmployeesCSV = async ({ fileObject, surveyId }) => {
  const res = await uploadEmployeesCSVApi({ fileObject, surveyId });
  return res;
};

export const getParticipants = async ({ surveyId }) => {
  const res = await getParticipantsApi({ surveyId });
  return res.entity;
};

export const putParticipantsCohort = async ({ surveyId, cohortId }) => {
  const res = await putParticipantsCohortApi({ surveyId, cohortId });
  return res.entity;
};
